import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { UserOccupancyFilterInput } from './inputs';
import { UserOccupancyResource } from './resources';
import { UserRefList } from './refs';

export default class UserOccupancy {
    private basePath = '/api/user-occupancy';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get list of user occupancy objects
    get = async (filter: UserOccupancyFilterInput): Promise<CollectionResource<UserOccupancyResource, {}>> => {
        const query = qs.stringify({ ...filter });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Process occupancy calculation for specific user ID
    processCalculation = async (userId: ID): Promise<UserRefList> => {
        const { data } = await this.http.post(`${this.basePath}/compute/id/${userId}`);

        return data;
    };
}
